import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import videoimg from '../../../assets/img/video-bg-2.jpg';

class Video extends Component {
    render() {
        return (
            <section className="video-section video-style-two" style={{ backgroundImage: "("+ videoimg +")" }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-8 col-md-10">
                            <div className="video-text text-center">
                                <div className="video-link-two">
                                    <Link to="#" className="popup-video"><i className="fas fa-play" /></Link>
                                </div>
                                <p>These values give us the foundations we need</p>
                                <h1>our values is only hard working</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Video;